<template>
    <ion-page>
        <ion-content>
            <div class="desktop-panel">
                <div style="width: 100%; height: 800px; position: relative">
                    <AuroraAnimation />
                </div>
                <div class="wrapper">
                    <div
                        :class="{ hide: emailIsSent }"
                        class="auth-intro-header"
                    >
                        <h1>{{ $t("auth.forgot-password.title") }}</h1>
                    </div>
                    <div
                        :class="{ show: emailIsSent }"
                        class="auth-intro-header email-sent"
                    >
                        <img
                            src="@/assets/images/sportspoule-logo.svg"
                            alt="Sportspoule"
                        />
                        <p class="message">
                            {{ $t("auth.forgot-password.email-sent") }}
                        </p>
                    </div>
                </div>
                <div class="actions">
                    <form
                        :class="{ hide: emailIsSent }"
                        @submit.prevent="handleForgotPassword"
                    >
                        <ion-input
                            id="email"
                            v-model="email"
                            name="email"
                            :placeholder="$t('fields.email')"
                            required
                            type="email"
                        />
                        <ion-button class="btn" expand="block" type="submit">
                            {{ $t("auth.forgot-password.cta") }}
                        </ion-button>

                        <div class="bottom-action">
                            {{ $t("auth.forgot-password.remember") }}
                            <br />
                            <span
                                class="primary"
                                @click="
                                    () => router.push({ name: 'auth.login' })
                                "
                            >
                                {{ $t("auth.forgot-password.back-to-login") }}
                            </span>
                        </div>
                    </form>
                </div>
            </div>
            <floating-back-button />
        </ion-content>
    </ion-page>
</template>

<script lang="ts" setup>
    import { IonButton, IonInput, IonContent, IonPage } from "@ionic/vue";
    import { ref } from "vue";
    import { useRouter } from "vue-router";
    import useAuth from "@/componentables/auth";
    import FloatingBackButton from "@/components/FloatingBackButton.vue";
    import AuroraAnimation from "@/components/animated/AuroraAnimation.vue";

    const router = useRouter();
    const email = ref("");
    const auth = useAuth();
    const emailIsSent = ref(false);

    const handleForgotPassword = () => {
        auth.forgotPassword(email.value).then(() => {
            emailIsSent.value = true;
        });
    };
</script>

<style lang="scss" scoped>
    @use "@/assets/scss/specific/auth" as *;

    .wrapper {
        position: absolute;
        top: 5%;
        left: 0;
        right: 0;
        padding-bottom: 88px;

        .auth-intro-header {
            position: relative;
            transition: all 0.4s ease-out 0.1s;

            &.hide {
                opacity: 0;
                transform: translateX(-32px);
            }

            &.email-sent {
                position: absolute;
                top: 0;
                left: 0;
                right: 0;
                display: flex;
                align-items: center;
                flex-direction: column;
                opacity: 0;
                transform: translateX(32px);
                transition: all 0.5s ease-out 0.4s;

                &.show {
                    opacity: 1;
                    transform: translateX(0);
                }

                img {
                    max-width: 96px;
                    max-height: 96px;
                    margin-bottom: vw(40px);
                    filter: drop-shadow(
                        0 8px 16px var(--color-always-black-alpha-20)
                    );
                }

                p {
                    font-size: 18px;
                    font-weight: 600;
                    line-height: 140%;
                    text-align: center;
                    color: var(--color-always-white);
                    padding: 0 24px;
                }
            }

            h1 {
                font-size: vw(32px);
                text-align: center;
                font-weight: 600;
            }
        }
    }

    .actions {
        form {
            &.hide {
                opacity: 0;
                transform: translateX(-32px);
                transition: all 0.6s ease-out 0.2s;
            }

            ion-input {
                --padding-start: 16px;
                --padding-end: 16px;
                margin-bottom: 8px;
                border: 1px solid var(--color-black-alpha-10);
            }

            .btn {
                margin-bottom: 16px;
            }

            .bottom-action {
                padding-top: vw(24px);
                font-size: 12px;
                font-weight: 600;
                line-height: 120%;
                text-align: center;
                color: var(--color-black-alpha-50);
            }
        }
    }
</style>
